/**
 * i18n.js
 */

const enTranslationMessages = require("./translations/en.json");
const zhTranslationMessages = require("./translations/zh.json");
export const DEFAULT_LOCALE = localStorage.getItem("selectedLanguage") || "en";

// prettier-ignore
export const appLocales = [
  'en',
  'zh',
];

export const formatTranslationMessages = (locale, messages) => {
  const defaultMessages =
    DEFAULT_LOCALE !== locale ? enTranslationMessages : {};
  return Object.keys(messages).reduce((formattedMessages, key) => {
    formattedMessages[key] = messages[key] || defaultMessages[key] || key;
    return formattedMessages;
  }, {});
};

export const translationMessages = {
  en: formatTranslationMessages("en", enTranslationMessages),
  zh: formatTranslationMessages("zh", zhTranslationMessages),
};
